import { gql } from "@apollo/client";

export default gql`
  fragment BettingInterests on Race {
    bettingInterests {
      biNumber
      favorite
      currentOdds {
        numerator
        denominator
      }
      morningLineOdds {
        numerator
        denominator
      }
      recentOdds(pages: { current: 0, results: 4 }) {
        trending
        odd
      }
      runners {
        runnerId
        scratched
        jockey
        trainer
        hasJockeyChanges
        winProbability
      }
    }
  }
`;
